import React, { ReactElement, ReactNode } from 'react';

import Link from 'src/components/Common/Link';
import Icon from 'src/components/Common/Icon';
import Picture from 'src/components/CE/Picture';

export const CardLogoSizeOptions = ['default', 'md', 'lg', 'xl'] as const;
type CardLogoSize = (typeof CardLogoSizeOptions)[number];

export const CardStyleOptions = ['colored', 'outline'] as const;
type CardStyle = (typeof CardStyleOptions)[number];

interface CardProps {
  children: ReactNode;
  color?: string;
  header?: ReactNode;
  image?: string;
  imgAlt?: string;
  imgPath?: string;
  link: string;
  logoSize?: CardLogoSize;
  style?: CardStyle;
  title?: string;
}

const Card = ({
  children,
  color,
  header,
  imgAlt,
  imgPath,
  image,
  link,
  logoSize,
  style,
  title,
}: CardProps): ReactElement => {
  const classes = ['ce-card'];
  if (style) {
    classes.push(`ce-card-${style}`);
  }
  if (color) {
    classes.push(color);
  }

  return (
    <Link className={classes.join(' ')} title={title} to={link}>
      <div className={logoSize ? `logo-size-${logoSize}` : null}>
        {(imgPath || image) && (
          <Picture alt={imgAlt} src={imgPath} image={image} />
        )}
        {header}
        {children}
        <div className="ce-card-cta">
          <span>Projektdetails</span> <Icon name="fa-arrow-right" />
        </div>
      </div>
    </Link>
  );
};

Card.defaultProps = {
  color: 'green',
  header: null,
  image: null,
  imgAlt: 'Projektlogo',
  imgPath: null,
  logoSize: 'default',
  style: 'colored',
  title: null,
};

export default Card;
